var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DinTestInstructions } from './din-test/din-test-instructions.component';
export function DinTestSidePanel() {
    return (_jsx("div", __assign({ className: "flex flex-col items-center justify-center h-full bg-beige p-10" }, { children: _jsx(DinTestInstructions, {}) })));
}
